import type { KolaborateApp } from "./apps";
import { getEnvironment, getRelease, getSentryDsn, getTracesSampleRate, isSentryEnabled } from "./env";
import { createBeforeSend, defaultDenyUrls, defaultIgnoreErrors } from "./filters";

export function createSentryOptions(app: KolaborateApp, overrides: Record<string, unknown> = {}) {
  const enabled = isSentryEnabled();

  return {
    dsn: getSentryDsn(),
    enabled,
    environment: getEnvironment(),
    release: getRelease(),
    tracesSampleRate: enabled ? getTracesSampleRate(app) : 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    enableLogs: false,
    ignoreErrors: defaultIgnoreErrors,
    denyUrls: defaultDenyUrls,
    beforeSend: createBeforeSend(),
    initialScope: {
      tags: {
        app,
        environment: getEnvironment(),
      },
    },
    ...overrides,
  };
}
